export default "__VITE_ASSET__a78e464d__"